// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"603":"eede413b","751":"6486a5dd"}[chunkId] + ".chunk.js";
};